// 📁 src/utils/expiryChecker.js

export const checkAndUpdateExpiryStatus = (email) => {
  try {
    const auditKey = `paymentAuditLog_${email}`;
    const logs = JSON.parse(localStorage.getItem(auditKey)) || [];
    const now = new Date();

    const updatedLogs = logs.map((entry) => {
      const expiry = new Date(entry.expiryDate);
      const isValidExpiry = expiry instanceof Date && !isNaN(expiry);

      // 🔒 Only flip status if expiry is valid and truly expired
      const isExpired = isValidExpiry && expiry < now;

      return {
        ...entry,
        paymentStatus: isExpired ? 'unpaid' : 'paid'
      };
    });

    localStorage.setItem(auditKey, JSON.stringify(updatedLogs));
    console.log(`✅ Expiry check complete for ${email}`);
  } catch (error) {
    console.error('❌ Expiry check failed:', error);
  }
};
